import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import styles from './OurServicesSection.module.scss'
import { ConstructionIcon } from 'components/CustomIcons'
import { 
  EcommerceHeaderIcon, 
  GamingHeaderIcon, 
  TechnologyHeaderIcon, 
  CommunityHeaderIcon, 
  EntertainmentHeaderIcon, 
  TravelHeaderIcon, 
  ComingSoonHeaderIcon,
  AllServicesIcon,
  EcommerceHeaderIconWhite,
  GamingHeaderIconWhite,
  TechnologyHeaderIconWhite,
  CommunityHeaderIconWhite,
  EntertainmentHeaderIconWhite,
  TravelHeaderIconWhite,
  ComingSoonHeaderIconWhite
} from 'components/CustomIcons/CategoryIcons'

import { 
  TaxiIcon, 
  JobIcon, 
  SpecialistsIcon, 
  FreelanceIcon, 
  NomadGameIcon, 
  MobileAppIcon,
  CyberProtectionIcon,
  GTAServerIcon,
  CloudGamingIcon,
  CyberCafeIcon
} from 'components/CustomIcons/FutureServicesIcons'

// Import New SVG Icons
import { 
  ShopIcon, 
  FoodIcon, 
  GamingIcon, 
  ServerIcon,
  ITIcon, 
  CommunityIcon, 
  MovieIcon, 
  AnimeIcon, 
  EventsIcon, 
  MediaIcon, 
  TourismIcon, 
  MedicineIcon,
  MusicIcon,
  DonationsIcon 
} from 'components/CustomIcons/MainServicesIcons'

// Import block images
// import animeImg from 'assets/imagesblock/anime.png'
// import donatsImg from 'assets/imagesblock/donats.png'
// import mediaImg from 'assets/imagesblock/media.png'
// import movieImg from 'assets/imagesblock/movie.png'
// import serversImg from 'assets/imagesblock/servers.png'
// import communityImg from 'assets/imagesblock/comunity.png'
// import musicImg from 'assets/imagesblock/music.png'

const OurServicesSection = ({ onOpenService }) => {
  const [activeCategory, setActiveCategory] = useState('all')
  const navigate = useNavigate()

  const iconComponents = {
    shop: ShopIcon,
    food: FoodIcon,
    servers: ServerIcon,
    it: ITIcon,
    community: CommunityIcon,
    movie: MovieIcon,
    anime: AnimeIcon,
    events: EventsIcon,
    media: MediaIcon,
    tourism: TourismIcon,
    medicine: MedicineIcon,
    donations: DonationsIcon,
    music: MusicIcon,
    taxi: TaxiIcon,
    job: JobIcon,
    specialists: SpecialistsIcon,
    freelance: FreelanceIcon,
    nomadgame: NomadGameIcon,
    mobileapp: MobileAppIcon,
    cyberprotection: CyberProtectionIcon,
    gtaserver: GTAServerIcon,
    cloudgaming: CloudGamingIcon,
    cybercafe: CyberCafeIcon
  }

  // const blockImages = {
  //   servers: serversImg,
  //   anime: animeImg,
  //   media: mediaImg,
  //   movie: movieImg,
  //   donations: donatsImg,
  //   community: communityImg,
  //   music: musicImg
  // }

  const serviceCategories = [
    {
      id: 'main-services',
      name: 'Основные сервисы',
      icon: GamingIcon,
      headerIcon: GamingHeaderIcon,
      whiteHeaderIcon: GamingHeaderIconWhite,
      gradient: 'rgba(255, 140, 0, 0.13)',
      services: [
        {
          id: 'servers',
          title: 'Игровые сервера',
          description: 'Хостинг игровых серверов высокого качества',
          icon: 'servers',
          color: '#9C27B0',
          features: ['DDoS защита', 'SSD накопители', 'Низкий пинг']
        },
        {
          id: 'community',
          title: 'Сообщество',
          description: 'Общайтесь, делитесь опытом и находите единомышленников',
          icon: 'community',
          color: '#E91E63',
          features: ['Форумы и обсуждения', 'Голосовые и текстовые чаты', 'Группы по интересам']
        }
      ]
    },
    {
      id: 'ecommerce',
      name: 'Интернет-коммерция',
      icon: ShopIcon,
      headerIcon: EcommerceHeaderIcon,
      whiteHeaderIcon: EcommerceHeaderIconWhite,
      gradient: 'linear-gradient(135deg, #2196F3 0%, #1565C0 100%)',
      services: [
        {
          id: 'shop',
          title: 'NCORE Shop',
          description: 'Покупайте товары онлайн с быстрой доставкой',
          icon: 'shop',
          color: '#4CAF50',
          features: ['Широкий ассортимент', 'Быстрая доставка', 'Безопасные платежи']
        },
        {
          id: 'it',
          title: 'NCORE IT Услуги',
          description: 'Разработка и техническая поддержка',
          icon: 'it',
          color: '#2196F3',
          features: ['Разработка ПО', 'Консультации', 'Поддержка 24/7']
        },
      ]
    },
    {
      id: 'entertainment',
      name: 'Развлечения',
      icon: MovieIcon,
      headerIcon: EntertainmentHeaderIcon,
      whiteHeaderIcon: EntertainmentHeaderIconWhite,
      gradient: 'linear-gradient(135deg, #F44336 0%, #D32F2F 100%)',
      services: [
        {
          id: 'movie',
          title: 'Фильмы',
          description: 'База данных фильмов и рейтинги',
          icon: 'movie',
          color: '#F44336',
          features: ['Огромная коллекция', 'HD качество', 'Рекомендации']
        },
        {
          id: 'music',
          title: 'Музыка',
          description: 'Стриминг музыки без ограничений',
          icon: 'music',
          color: '#1DB954',
          features: ['Высокое качество', 'Плейлисты', 'Артисты']
        },
        {
          id: 'anime',
          title: 'Аниме',
          description: 'Каталог аниме и манги',
          icon: 'anime',
          color: '#673AB7',
          features: ['Субтитры', 'Новинки', 'Рейтинги']
        },
        {
          id: 'media',
          title: 'Медиа',
          description: 'Новости, обзоры и игровой контент',
          icon: 'media',
          color: '#795548',
          features: ['Актуальные новости', 'Обзоры', 'Статьи']
        }
      ]
    },
    {
      id: 'coming-soon',
      name: 'Скоро',
      icon: MedicineIcon,
      headerIcon: ComingSoonHeaderIcon,
      whiteHeaderIcon: ComingSoonHeaderIconWhite,
      gradient: 'linear-gradient(135deg, #4CAF50 0%, #45a049 100%)',
      services: [
        {
          id: 'donations',
          title: 'Донаты',
          description: 'Пополнение игровых валют и покупка ваучеров',
          icon: 'donations',
          color: '#FF6B35',
          inDevelopment: true,
          features: ['Моментальное пополнение', 'Игровые валюты', 'Коды ваучеров']
        },
        {
          id: 'food',
          title: 'Доставка еды',
          description: 'Поиск ресторанов и заказ еды',
          icon: 'food',
          color: '#FF9800',
          inDevelopment: true,
          features: ['Лучшие рестораны', 'Быстрая доставка', 'Онлайн оплата']
        },
        {

          id: 'events',
          title: 'Мероприятия',
          description: 'Участвуйте в интересных событиях',
          icon: 'events',
          color: '#FF5722',
          inDevelopment: true,
          features: ['Онлайн события', 'Встречи', 'Конкурсы']
        },
        {
          id: 'tourism',
          title: 'Туризм',
          description: 'Бронируйте туры и путешествия',
          icon: 'tourism',
          color: '#00BCD4',
          inDevelopment: true,
          features: ['Туры по миру', 'Лучшие отели', 'Гиды']
        },
        {
          id: 'medicine',
          title: 'Медицина',
          description: 'Сообщество медиков',
          icon: 'medicine',
          color: '#4CAF50',
          comingSoon: true,
          features: ['Консультации', 'Записи к врачам', 'База знаний']
        },
        {
          id: 'taxi',
          title: 'N-Taxi',
          description: 'Сервис заказа такси',
          icon: 'taxi',
          color: '#FFCA28',
          inDevelopment: true,
          features: ['Быстрая подача', 'Выгодные тарифы', 'Безопасность']
        },
        {
          id: 'job',
          title: 'Поиск работы',
          description: 'Вакансии и карьера',
          icon: 'job',
          color: '#607D8B',
          inDevelopment: true,
          features: ['Актуальные вакансии', 'Резюме', 'Прямой контакт']
        },
        {
          id: 'specialists',
          title: 'Поиск специалистов',
          description: 'База проверенных экспертов',
          icon: 'specialists',
          color: '#3F51B5',
          inDevelopment: true,
          features: ['Рейтинг спецов', 'Отзывы', 'Портфолио']
        },
        {
          id: 'freelance',
          title: 'Заказы и Фриланс',
          description: 'Биржа заданий и услуг',
          icon: 'freelance',
          color: '#9C27B0',
          inDevelopment: true,
          features: ['Безопасная сделка', 'Разные категории', 'Быстрый старт']
        },
        {
          id: 'nomadgame',
          title: 'Nomad Worlds',
          description: 'Серия RPG игр о кочевниках',
          icon: 'nomadgame',
          color: '#E91E63',
          inDevelopment: true,
          features: ['PC / Xbox / Mobile', 'Открытый мир', 'Сюжет']
        },
        {
          id: 'mobileapp',
          title: 'NCORE App',
          description: 'Единый центр управления',
          icon: 'mobileapp',
          color: '#009688',
          inDevelopment: true,
          features: ['Вся экосистема', 'Удобный интерфейс', 'Уведомления']
        },
        {
          id: 'cyberprotection',
          title: 'Кибер защита детей',
          description: 'Для родителей',
          icon: 'cyberprotection',
          color: '#D32F2F',
          inDevelopment: true,
          features: ['Контроль контента', 'Лимиты времени', 'Безопасность']
        },
        {
          id: 'gtaserver',
          title: 'Новые игровые сервера',
          description: 'GTA 5 RP, Rust, Roblox',
          icon: 'gtaserver',
          color: '#FFA726',
          inDevelopment: true,
          features: ['Уникальные миры', 'RP режимы', 'Низкий пинг']
        },
        {
          id: 'cloudgaming',
          title: 'Облачный Гейминг',
          description: 'Играйте в мощные игры через сайт',
          icon: 'cloudgaming',
          color: '#00B0FF',
          inDevelopment: true,
          features: ['Мощное железо', 'Запуск в браузере', 'Любая игра']
        },
        {
          id: 'cybercafe',
          title: 'Единая сеть клубов',
          description: 'Система для компьютерных клубов',
          icon: 'cybercafe',
          color: '#7C4DFF',
          inDevelopment: true,
          features: ['Онлайн бронь', 'Единый аккаунт', 'Заказы еды']
        }
      ]
    }
  ]

  const filteredCategories = activeCategory === 'all' 
    ? serviceCategories 
    : serviceCategories.filter(cat => cat.id === activeCategory)

  const mainCategories = filteredCategories.filter(c => c.id !== 'coming-soon')
  // Always show coming-soon section regardless of filter
  const comingSoonCategory = serviceCategories.find(c => c.id === 'coming-soon')

  const renderCard = (service, categoryIndex, serviceIndex) => {
    const ServiceIcon = iconComponents[service.icon]
    return (
      <div
        key={service.id}
        className={`${styles.serviceCard} ${service.inDevelopment ? styles.inDevelopment : ''} ${service.comingSoon ? styles.comingSoon : ''}`}
        onClick={() => !service.comingSoon && !service.inDevelopment && onOpenService(service.id)}
        style={{
          '--accent-color': service.color
        }}
      >
        <div className={styles.cardGlow} style={{ background: service.color }}></div>
        <div className={styles.cardContent}>
          <div className={styles.cardLeft}>
            <div
              className={styles.iconWrapper}
              style={{ background: `${service.color}1a`, border: `1.5px solid ${service.color}33` }}
            >
              <ServiceIcon className={styles.serviceIcon} style={{ color: service.color }} />
            </div>
            <h3 className={styles.serviceTitle}>{service.title}</h3>
            <p className={styles.serviceDescription}>{service.description}</p>
            {service.comingSoon ? (
              <div className={styles.developmentBadge}>
                <ConstructionIcon className={styles.devIcon} size={18} />
                В разработке
              </div>
            ) : (
              <>
                {!service.inDevelopment && (
                  <div className={styles.cardFooter}>
                    <span className={styles.serviceLink}>Открыть сервис</span>
                    <span className={styles.serviceArrow}>→</span>
                  </div>
                )}
                {service.inDevelopment && (
                  <div className={styles.developmentNote}>
                    <ConstructionIcon className={styles.devIcon} size={16} />
                    Данный раздел ещё в разработке
                  </div>
                )}
              </>
            )}
          </div>
          {/* {blockImages[service.id] && (
            <div className={styles.cardRight}>
              <img src={blockImages[service.id]} alt={service.title} className={styles.blockImage} />
            </div>
          )} */}
        </div>
      </div>
    )
  }

  return (
    <section className={styles.section}>
      <div className={styles.container}>

        {/* Category Filter */}
        {/* Category Filter */}
        <div className={styles.categoryFilter}>
          <button 
            className={`${styles.filterButton} ${activeCategory === 'all' ? styles.active : ''}`}
            onClick={() => setActiveCategory('all')}
          >
            {/* <AllServicesIcon className={styles.filterIcon} size={20} /> */}
            <span>Все сервисы</span>
          </button>
          {serviceCategories.map(category => {
            const CategoryHeaderIcon = category.headerIcon
            return (
              <button 
                key={category.id}
                className={`${styles.filterButton} ${activeCategory === category.id ? styles.active : ''}`}
                onClick={() => setActiveCategory(category.id)}
              >
                {/* <CategoryHeaderIcon className={styles.filterIcon} size={22} /> */}
                <span>{category.name}</span>
              </button>
            )
          })}
        </div>

        {/* Main service cards — flat grid */}
        <div className={styles.servicesGrid}>
          {mainCategories.map((category, categoryIndex) => (
            <React.Fragment key={category.id}>
              {category.services.map((service, serviceIndex) => renderCard(service, categoryIndex, serviceIndex))}
            </React.Fragment>
          ))}
        </div>

        {/* Coming soon section */}
        {comingSoonCategory && (
          <div className={styles.comingSoonSection}>
            <div className={styles.comingSoonHeader}>
              <h3 className={styles.comingSoonTitle}>Скоро</h3>
              <div className={styles.categoryLine} />
            </div>
            <div className={styles.servicesGrid}>
              {comingSoonCategory.services.map((service, idx) => renderCard(service, 99, idx))}
            </div>
          </div>
        )}
      </div>
    </section>
  )
}

export default OurServicesSection